export default [
  {
    path: '/authenticate',
    name: 'authenticate',
    component: require('./authenticate-view').default
  }
]
